import { mapState, mapMutations } from 'vuex'
import { randomString } from '@/utils/Common'
import { Device } from "@/utils/Capacitor";

export const accountMixin = {
    data() {
        return {
            isIphone: false,
        }
    },
    computed: {
        ...mapState(['currentUser', 'account', 'preventRouteLeaveFn', 'dialogActive']),
        currentQuery() {
            const vm = this
            let query = {}
            if (Object.keys(vm.$route.query).length > 0) query = vm.$route.query
            return query
        },
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown
        },
        appName() {
            return process.env.VUE_APP_NAME
        },
        imgPlaceholder() {
            return require('@/assets/img/logo.png')
        },
        discordWebhook() {
            return process.env.VUE_APP_DISCORD_WEBHOOK || null
        },
        isFreePlan(vm = this) {
            return vm.account?.stripeAccount?.currentSubscription?.isFree === true
        },
        accountType(vm = this) {
            let accountType = vm.account?.accountType || ''
            if (accountType === 'coach_company') accountType = 'coach'
            return accountType
        },
        versionAppCode() {
            return process.env.VUE_APP_VERSION_APP || null
        },
    },
    async mounted() {
        this.isIphone = await Device.isIphone()
    },
    methods: {
        ...mapMutations(['showSnackBar', 'setDialogActive', 'setPreventRouteLeaveFn']),
        randomString,
        toast(message = '', color = 'success', closeColor = 'white') {
            const vm = this
            vm.showSnackBar({ text: message, color: color, closeColor: closeColor })
        },
        onBackPress(fn = () => { }) {
            const vm = this
            vm.setPreventRouteLeaveFn(fn)
        },
        clearOnBack() {
            const vm = this
            vm.setPreventRouteLeaveFn(null)
        },
        goHome(replace = false) {
            const vm = this
            if (vm.accountType) return vm.$router.push({ name: `${vm.accountType}.home`, replace: replace })
        },
    },
    watch: {}
}

export const links = {

    data(vm) {
        return {
            coach: [
                { ref: 'home', title: vm.$t('common.home'), icon: '$home', link: { name: 'coach.home' } },
                { ref: 'students', title: vm.$tc('student.student', 2), icon: '$account_multiple', link: { name: 'coach.students' }, count: 0 },
                { ref: 'library', title: vm.$t('common.library'), icon: '$training', link: { name: 'coach.library' } },
                { ref: 'calendar', title: vm.$t('common.calendar'), icon: '$calendar', link: { name: 'coach.calendar' } },
                { ref: 'statistics', title: vm.$t('common.statistics'), icon: '$statistics', link: { name: 'coach.statistics' } },
                { ref: 'evaluations', title: vm.$t('common.evaluations'), icon: 'mdi-book-open-variant', link: { name: 'coach.evaluations' } },
                { ref: 'profile', title: vm.$t('common.profile'), icon: '$account_circle', link: { name: 'coach.profile' } }
            ],
            studentWithCoach: [
                { ref: 'home', title: vm.$t('common.home'), icon: '$home', link: { name: 'student.home' } },
                { ref: 'chats', title: vm.$t('common.my_chats'), icon: 'mdi-message-outline', link: { name: 'student.chats' }, count: 0 },
                { ref: 'routines', title: vm.$t('common.routines'), icon: '$training', link: { name: 'student.routines' } },
                { ref: 'statistics', title: vm.$t('common.statistics'), icon: '$statistics', link: { name: 'student.statistics' } },
                { ref: 'profile', title: vm.$t('common.profile'), icon: '$account_circle', link: { name: 'student.profile' } }
            ],
            student: [
                { ref: 'home', title: vm.$t('common.home'), icon: '$home', link: { name: 'student.home' } },
                { ref: 'coaches', title: vm.$tc('coach.coach', 2), icon: '$account_multiple', link: { name: 'student.coaches' } },
                { ref: 'routines', title: vm.$t('common.routines'), icon: '$training', link: { name: 'student.routines' } },
                { ref: 'profile', title: vm.$t('common.profile'), icon: '$account_circle', link: { name: 'student.profile' } }
            ],
            company: [
                { ref: 'home', title: vm.$t('common.home'), icon: '$home', link: { name: 'company.home' } },
                { ref: 'admin', title: vm.$t('common.admin_gym'), icon: '$company', link: { name: 'company.admin' } },
                { ref: 'routines', title: vm.$t('common.routines'), icon: '$training', link: { name: 'company.routines' } },
                { ref: 'exercises', title: vm.$t('common.exercises'), icon: 'mdi-dumbbell', link: { name: 'company.exercises' } },
                { ref: 'calendar', title: vm.$t('common.calendar'), icon: '$calendar', link: { name: 'company.calendar' } },
                { ref: 'statistics', title: vm.$t('common.statistics'), icon: '$statistics', link: { name: 'company.statistics' } },
                { ref: 'profile', title: vm.$t('common.profile'), icon: '$account_circle', link: { name: 'company.profile' } }
            ],
        }
    },
    computed: {
        currentItems(vm = this) {
            if (vm.accountType === 'company') return vm.company
            if (vm.accountType === 'coach') return vm.coach
            if (vm.account?.studentSubscription) return vm.studentWithCoach
            return vm.student
        },
        items(vm = this) {
            let items = vm.currentItems
            if (vm.isMobile) items = items.filter(item => item.ref !== 'evaluations') // delete evaluations in mobile version
            if (items[1]?.count) items[1].count = vm.account?.counter?.messages || 0
            if (vm.isFreePlan) items = items.filter(item => item.ref !== 'statistics' && item.ref !== 'evaluations')
            return items
        }
    }
}